(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sanalio-ingredients-focus"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('snl-ingredient-focus')){
class SnlIngredientFocus extends HTMLElement{
 connectedCallback(){
  if(this.controller)return;
  this.controller=new AbortController();const signal=this.controller.signal;
  this.slides=[...this.querySelectorAll('[data-slide]')];if(!this.slides.length)return;
  this.current=0;this.reduced=matchMedia('(prefers-reduced-motion: reduce)');
  this.querySelectorAll('[hidden]').forEach(el=>el.hidden=false);
  this.classList.add('snlf--ready');
  this.querySelector('[data-prev]').addEventListener('click',()=>this.move(-1),{signal});
  this.querySelector('[data-next]').addEventListener('click',()=>this.move(1),{signal});
  this.querySelector('.snlf__before').addEventListener('click',()=>this.move(-1),{signal});
  this.querySelector('.snlf__after').addEventListener('click',()=>this.move(1),{signal});
  this.querySelectorAll('[data-panel]').forEach(btn=>btn.addEventListener('click',()=>this.panel(btn.closest('[data-slide]'),btn.dataset.panel),{signal}));
  this.addEventListener('keydown',e=>{if(e.target.matches('select,input,textarea'))return;if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();this.move(e.key==='ArrowRight'?1:-1)}},{signal});
  const stage=this.querySelector('.snlf__stage');let start=null;
  stage.addEventListener('pointerdown',e=>{if(e.pointerType==='touch')start={x:e.clientX,y:e.clientY}},{signal});
  stage.addEventListener('pointerup',e=>{if(start){const dx=e.clientX-start.x,dy=e.clientY-start.y;if(Math.abs(dx)>45&&Math.abs(dx)>Math.abs(dy)*1.3)this.move(dx<0?1:-1);start=null}},{signal});
  stage.addEventListener('pointercancel',()=>start=null,{signal});
  document.addEventListener('shopify:block:select',e=>{const i=this.slides.findIndex(s=>s.dataset.block===e.detail.blockId);if(i>=0)this.show(i,0)},{signal});
  this.show(0,0);
 }
 panel(slide,key){slide.querySelectorAll('[data-panel]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.panel===key)));slide.querySelectorAll('[data-content]').forEach(p=>{const active=p.dataset.content===key;p.classList.toggle('is-active',active);p.inert=!active;p.setAttribute('aria-hidden',String(!active))})}
 move(delta){this.show((this.current+delta+this.slides.length)%this.slides.length,delta)}
 show(index,direction){
  const focusedSlide=document.activeElement?.closest('[data-slide]');
  if(focusedSlide&&focusedSlide!==this.slides[index])this.querySelector(direction<0?'[data-prev]':'[data-next]').focus({preventScroll:true});
  this.current=index;this.animation?.cancel();
  this.slides.forEach((slide,i)=>{const active=i===index;slide.classList.toggle('is-active',active);slide.inert=!active;slide.setAttribute('aria-hidden',String(!active));this.panel(slide,'role')});
  this.querySelector('.snlf__announcement').textContent=this.slides[index].dataset.name+' · '+String(index+1)+' / '+String(this.slides.length);
  this.querySelector('.snlf__arrows').hidden=this.slides.length<2;
  for(const [cls,delta,label] of [['.snlf__before',-1,this.dataset.previous],['.snlf__after',1,this.dataset.next]]){
   const btn=this.querySelector(cls),other=this.slides[(index+delta+this.slides.length)%this.slides.length],img=other.querySelector('.snlf__photo img');
   btn.hidden=this.slides.length<2||!img;
   if(img){btn.querySelector('img').src=img.currentSrc||img.src;btn.setAttribute('aria-label',label+' : '+other.dataset.name)}
  }
  this.querySelector('[data-prev]').disabled=this.slides.length<2;this.querySelector('[data-next]').disabled=this.slides.length<2;
  if(direction&&!this.reduced.matches)this.animation=this.slides[index].animate([{transform:`translateX(${direction*32}px) scale(.985)`,opacity:.35},{transform:'translateX(0) scale(1)',opacity:1}],{duration:430,easing:'cubic-bezier(.16,1,.3,1)'});
 }
 disconnectedCallback(){this.controller?.abort();this.controller=null;this.animation?.cancel()}
}
customElements.define('snl-ingredient-focus',SnlIngredientFocus);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sanalio-pack-offer"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-snl-pack]').forEach(function (root) {
  if (root.dataset.snlPackInit) return;
  root.dataset.snlPackInit = '1';

  /* Sélecteur d'offres : radio → variante + prix du CTA + état visuel */
  var hidden = root.querySelector('[data-snl-pack-variant]');
  var ctaLabel = root.querySelector('[data-snl-pack-cta]');
  var ctaPrefix = ctaLabel ? ctaLabel.textContent.split('—')[0].trim() : '';
  root.querySelectorAll('[data-snl-pack-offer]').forEach(function (radio) {
    radio.addEventListener('change', function () {
      if (hidden) hidden.value = radio.value;
      if (ctaLabel && radio.dataset.price) ctaLabel.textContent = ctaPrefix + ' — ' + radio.dataset.price;
      root.querySelectorAll('[data-snl-pack-opt]').forEach(function (opt) {
        opt.classList.toggle('is-selected', opt.contains(radio));
      });
    });
  });

  /* Cadeaux : encarts dépliables (un seul ouvert) */
  root.querySelectorAll('[data-snl-pack-gift]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var wrap = btn.nextElementSibling;
      if (!wrap || !wrap.hasAttribute('data-snl-pack-card')) return;
      var willOpen = !wrap.classList.contains('is-open');
      var scope = btn.closest('.snlPack-gifts') || root;
      scope.querySelectorAll('[data-snl-pack-card]').forEach(function (w) { w.classList.remove('is-open'); });
      scope.querySelectorAll('[data-snl-pack-gift]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      if (willOpen) { wrap.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true'); }
    });
  });

  /* Galerie : vignettes */
  var main = root.querySelector('.snlPack-mainimg');
  root.querySelectorAll('[data-snl-pack-thumb]').forEach(function (t) {
    t.addEventListener('click', function () {
      if (!main) return;
      main.src = t.dataset.src;
      main.removeAttribute('srcset');
      root.querySelectorAll('[data-snl-pack-thumb]').forEach(function (x) { x.classList.toggle('is-active', x === t); });
    });
  });

  /* ATC : enrichissement AJAX par-dessus le formulaire natif */
  var form = root.querySelector('[data-snl-pack-form]');
  if (form && window.fetch) {
    form.addEventListener('submit', function onSubmit(e) {
      e.preventDefault();
      var cta = form.querySelector('.snlPack-cta');
      if (cta) cta.disabled = true;
      fetch(root.dataset.cartUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: hidden ? hidden.value : '', quantity: 1 })
      }).then(function (r) {
        if (!r.ok) throw new Error('cart');
        return r.json();
      }).then(function () {
        try {
          document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
          if (window.Alpine && Alpine.store('xMiniCart') && Alpine.store('xMiniCart').openCart) {
            Alpine.store('xMiniCart').openCart();
            if (cta) cta.disabled = false;
            return;
          }
        } catch (err) { /* thème absent : on retombe sur l'état inline */ }
        if (cta) {
          cta.disabled = false;
          cta.classList.add('is-done');
          if (ctaLabel) ctaLabel.textContent = '✓ Ajouté — voir le panier';
          cta.addEventListener('click', function go(ev) {
            ev.preventDefault();
            window.location.href = root.dataset.cartPage;
          }, { once: true });
        }
      }).catch(function () {
        form.removeEventListener('submit', onSubmit);
        form.submit(); /* repli : POST natif vers /cart/add */
      });
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sanalio-pdp-benefits"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sanalio-product-benefits')) {
 customElements.define('sanalio-product-benefits', class extends HTMLElement {
  connectedCallback() {
   if (this.controller) return;
   this.controller = new AbortController();
   this.addEventListener('shopify:block:select', event => {
    const card = event.target.closest('[data-benefit-id]');
    const details = card?.querySelector('details');
    if (details) details.open = true;
   }, {signal:this.controller.signal});
   if (this.dataset.animate !== 'true' || matchMedia('(prefers-reduced-motion: reduce)').matches || (window.Shopify && window.Shopify.designMode)) return;
   this.observer = new IntersectionObserver(entries => {
    for (const entry of entries) {
     if (!entry.isIntersecting) continue;
     entry.target.animate([{opacity:0,transform:'translateY(10px)'},{opacity:1,transform:'translateY(0)'}],{duration:380,easing:'ease-out'});
     this.observer.unobserve(entry.target);
    }
   },{threshold:0.15});
   this.querySelectorAll('.snlPdpBenefits__photo,.snlPdpBenefits__benefit').forEach(card => this.observer.observe(card));
  }
  disconnectedCallback() { this.controller?.abort();this.observer?.disconnect();this.controller=null; }
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sanalio-product-reviews"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('sanalio-product-reviews')) {
 customElements.define('sanalio-product-reviews', class extends HTMLElement {
  connectedCallback() {
   if (this.controller) return;
   this.controller = new AbortController(); this.frame = 0; this.sortApplied = false;
   this.motion = matchMedia('(prefers-reduced-motion: reduce)');
   this.schedule = () => { if (!this.frame) this.frame = requestAnimationFrame(() => { this.frame = 0; this.refresh(); }); };
   this.addEventListener('change', event => {
    if (event.target.matches('.jdgm-sort-dropdown')) { this.sortApplied = true; this.release(); }
   }, { capture:true, signal:this.controller.signal });
   this.addEventListener('click', event => {
    const button = event.target.closest('[data-review-prev],[data-review-next]');
    if (!button || !this.list || this.pending) return;
    this.navigate(button.hasAttribute('data-review-prev') ? -1 : 1);
   }, { signal:this.controller.signal });
   this.observer = new MutationObserver(this.schedule);
   this.observer.observe(this,{subtree:true,childList:true,attributes:true,attributeFilter:['disabled','aria-current']});
   this.resizeObserver = new ResizeObserver(this.schedule); this.resizeObserver.observe(this);
   window.addEventListener('resize',this.schedule,{passive:true,signal:this.controller.signal});
   this.schedule();
  }
  nativeButton(direction) {
   const buttons = this.querySelectorAll('.jm-pagination-controls__button--nav');
   return direction < 0 ? buttons[0] : buttons[buttons.length-1];
  }
  release() {
   clearTimeout(this.pendingTimer); this.pending = false;
   this.querySelector('.snlProductReviews')?.classList.remove('snlProductReviews--loading');
  }
  navigate(direction) {
   const max = Math.max(0,this.list.scrollWidth-this.list.clientWidth);
   const hasMore = direction < 0 ? this.list.scrollLeft > 3 : this.list.scrollLeft < max-3;
   if (hasMore) {
    const card = this.list.querySelector('.jm-review-item');
    const step = card.getBoundingClientRect().width + (parseFloat(getComputedStyle(this.list).gap) || 0);
    this.list.scrollBy({left:direction*step,behavior:this.motion.matches ? 'instant':'smooth'});
    return;
   }
   const next = this.nativeButton(direction);
   if (!next || next.disabled) return;
   this.pending = true; this.direction = direction;
   this.querySelector('.snlProductReviews').classList.add('snlProductReviews--loading');
   this.schedule();
   this.pendingTimer = setTimeout(() => { this.release(); this.schedule(); },12000);
   next.click();
  }
  enhancePhotos() {
   for (const card of this.querySelectorAll('.jdgm-review-list > .jm-review-item')) {
    const rail = [...card.querySelectorAll(':scope > .jm-stack > .jm-cluster')].find(node => node.querySelector('.jm-media-thumbnail-list__thumbnail--default img'));
    card.classList.toggle('snlReviewWithPhoto',!!rail);
    if (!rail) continue;
    rail.classList.add('snlReviewPhotoRail');
    const photos = rail.querySelectorAll('.jm-media-thumbnail-list__thumbnail--default img');
    if (photos.length > 1) rail.dataset.snlExtraPhotos = String(photos.length-1);
    else delete rail.dataset.snlExtraPhotos;
    if (!this.querySelector('.snlProductReviews--photos-full')) continue;
    for (const img of photos) {
     if (img.dataset.snlPhotoUpgraded) continue;
     const candidates = (img.getAttribute('srcset') || '').split(',').map(value => value.trim().split(/\s+/)).filter(parts => parts[0]);
     if (candidates.length < 2) continue;
     const largest = candidates.sort((a,b) => (parseFloat(b[1]) || 0)-(parseFloat(a[1]) || 0))[0][0];
     img.dataset.snlPhotoUpgraded = 'true';
     img.setAttribute('srcset',largest+' 1x');
    }
   }
  }
  refresh() {
   this.enhancePhotos();
   const select = this.querySelector('.jdgm-sort-dropdown');
   if (select && !this.sortApplied) {
    const wanted = this.dataset.initialSort;
    this.sortApplied = true;
    if (wanted !== 'unchanged' && [...select.options].some(o => o.value === wanted) && select.value !== wanted) {
     select.value = wanted;
     select.dispatchEvent(new Event('change',{bubbles:true}));
    }
   }
   const list = this.querySelector('.snlProductReviews--carousel .jdgm-review-list');
   const controls = this.querySelector('.snlProductReviews__carousel-tools');
   if (!list || !controls) return;
   if (this.list !== list) {
    this.listController?.abort(); this.listController = new AbortController(); this.list = list;
    list.addEventListener('scroll',this.schedule,{passive:true,signal:this.listController.signal});
    list.addEventListener('keydown',event => {
     if (event.target !== list || !['ArrowLeft','ArrowRight'].includes(event.key)) return;
     event.preventDefault();
     this.querySelector(event.key === 'ArrowLeft' ? '[data-review-prev]' : '[data-review-next]')?.click();
    },{signal:this.listController.signal});
    list.setAttribute('tabindex','0');
    list.setAttribute('aria-label',controls.querySelector('p').textContent);
   }
   const cards = [...list.querySelectorAll(':scope > .jm-review-item')];
   const key = cards.map(c => c.getAttribute('review-uuid')).join('|');
   if (key !== this.cardsKey) {
    const wasPending = this.pending;
    this.cardsKey = key; this.release();
    list.scrollTo({left:wasPending && this.direction < 0 ? list.scrollWidth : 0,behavior:'instant'});
    if (this.dataset.motion === 'true' && !this.motion.matches) cards.forEach((card,i) => {
     card.animate([{opacity:0,transform:'translateY(8px)'},{opacity:1,transform:'translateY(0)'}],{duration:320,delay:i*35,easing:'ease-out'});
    });
   }
   const max = Math.max(0,list.scrollWidth-list.clientWidth);
   const prev = this.nativeButton(-1), next = this.nativeButton(1);
   const canPrev = list.scrollLeft > 3 || (prev && !prev.disabled);
   const canNext = list.scrollLeft < max-3 || (next && !next.disabled);
   controls.hidden = !cards.length || !(canPrev || canNext || this.pending);
   for (const [selector,disabled] of [['[data-review-prev]',!!this.pending || !canPrev],['[data-review-next]',!!this.pending || !canNext]]) {
    const button = this.querySelector(selector);
    if (button.disabled !== disabled) button.disabled = disabled;
   }
   const root = this.querySelector('.snlProductReviews');
   root.classList.toggle('snlProductReviews--enhanced',!!(prev && next));
  }
  disconnectedCallback() {
   this.release();this.controller?.abort();this.listController?.abort();this.observer?.disconnect();this.resizeObserver?.disconnect();cancelAnimationFrame(this.frame);this.controller=null;
  }
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sanalio-transition-guide"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sanalio-transition-guide')) {
 customElements.define('sanalio-transition-guide', class extends HTMLElement {
  connectedCallback() {
   if (this.controller) return;
   this.controller = new AbortController(); this.frame = 0;
   this.motion = matchMedia('(prefers-reduced-motion: reduce)');
   const schedule = () => { if (!this.frame) this.frame = requestAnimationFrame(() => { this.frame = 0; this.updateTimeline(); }); };
   window.addEventListener('scroll', schedule, { passive:true, signal:this.controller.signal });
   window.addEventListener('resize', schedule, { passive:true, signal:this.controller.signal });
   this.motion.addEventListener('change', schedule, { signal:this.controller.signal });
   this.addEventListener('toggle', schedule, { capture:true, signal:this.controller.signal });
   this.addEventListener('click', event => {
    const link = event.target.closest('.snlTransitionGuide__nav a');
    if (!link) return;
    const row = document.getElementById(link.hash.slice(1));
    if (!row || !this.contains(row)) return;
    event.preventDefault();
    this.classList.remove('is-stackable');
    row.scrollIntoView({ behavior:'instant', block:'start' });
    schedule();
   }, { signal:this.controller.signal });
   this.addEventListener('focusin', event => {
    const row = event.target.closest('.snlTransitionStep');
    if (row && event.target.matches(':focus-visible') && this.classList.contains('is-stackable')) {
     this.classList.remove('is-stackable');
     row.scrollIntoView({ behavior:'instant', block:'start' });
     schedule();
    }
   }, { signal:this.controller.signal });
   this.addEventListener('shopify:block:select', event => {
    const card = event.target.closest('.snlTransitionStep');
    if (card) card.scrollIntoView({ behavior:'instant', block:'center' });
   }, { signal:this.controller.signal });
   this.resizeObserver = new ResizeObserver(schedule); this.resizeObserver.observe(this);
   schedule();
  }
  updateTimeline() {
   const list = this.querySelector('.snlTransitionGuide__steps');
   if (!list) return;
   const rows = [...list.querySelectorAll(':scope > .snlTransitionStep')];
   rows.forEach((row,index) => row.style.setProperty('--step-index',index));
   const navList = this.querySelector('.snlTransitionGuide__nav ol');
   const navKey = rows.map(row => row.id + row.querySelector('h3')?.textContent).join('|');
   if (this.navKey !== navKey) {
    this.navKey = navKey;
    const fragment = document.createDocumentFragment();
    rows.forEach((row,index) => {
     const item = document.createElement('li'), link = document.createElement('a');
     const number = document.createElement('span'), label = document.createElement('span');
     link.setAttribute('href','#' + row.id);
     number.className = 'snlTransitionGuide__nav-number'; number.setAttribute('aria-hidden','true');
     number.textContent = String(index+1).padStart(2,'0');
     label.textContent = row.querySelector('h3')?.textContent || '';
     link.append(number,label); item.append(link); fragment.append(item);
    });
    navList.replaceChildren(fragment);
   }
   const intro = this.querySelector('.snlTransitionGuide__intro');
   const styles = getComputedStyle(this);
   const top = parseFloat(styles.getPropertyValue('--st-sticky-top')) || 144;
   const offset = parseFloat(styles.getPropertyValue('--st-offset')) || 20;
   const desktop = matchMedia('(min-width:990px)').matches;
   const fits = rows.every((row,index) => row.offsetHeight + top + index * offset + 24 < innerHeight);
   this.classList.toggle('is-stackable', desktop && fits && this.dataset.stack === 'true' && !this.motion.matches && !this.querySelector('details[open]'));
   this.classList.toggle('is-pinnable', desktop && intro.offsetHeight + top + 24 < innerHeight && !this.motion.matches);
   const trigger = desktop ? top + 120 : innerHeight * .55;
   let active = 0;
   rows.forEach((row,index) => { if (row.getBoundingClientRect().top <= trigger + index * offset) active = index; });
   const links = [...this.querySelectorAll('.snlTransitionGuide__nav a')];
   links.forEach((link,index) => {
    if (index === active) link.setAttribute('aria-current','step'); else link.removeAttribute('aria-current');
    link.parentElement.classList.toggle('is-complete', this.dataset.animate !== 'true' || this.motion.matches || index < active);
   });
   const rail = this.querySelector('.snlTransitionGuide__rail');
   const dots = rows.map(row => row.querySelector('.snlTransitionStep__number'));
   rail.hidden = dots.length < 2;
   if (!desktop && dots.length) {
    const rect = list.getBoundingClientRect();
    const first = dots[0].getBoundingClientRect(), last = dots[dots.length-1].getBoundingClientRect();
    const start = first.top + first.height/2, end = last.top + last.height/2;
    rail.style.top = `${start-rect.top}px`; rail.style.left = `${first.left+first.width/2-rect.left}px`;
    rail.style.height = `${Math.max(0,end-start)}px`; rail.style.bottom = 'auto';
    const staticLine = this.dataset.animate !== 'true' || this.motion.matches;
    rail.style.setProperty('--st-read-progress',staticLine ? 1 : Math.max(0,Math.min(1,(trigger-start)/Math.max(1,end-start))));
    rows.forEach((row,index) => row.classList.toggle('is-active',staticLine || dots[index].getBoundingClientRect().top <= trigger));
   }
  }
  disconnectedCallback() { this.controller?.abort();this.resizeObserver?.disconnect();cancelAnimationFrame(this.frame);this.controller=null; }
 });
}

  } catch(e) { console.error(e); }
})();
})();
